<template>
  <div
    class="already-have-an-account-container"
    :class="{ 'large-already': type === 'login' }"
  >
    <p v-if="type === 'login'">
      You don’t have an account? <span @click="handleSignup">Sign up here</span>
    </p>
    <p v-else>
      Already have an account? <span @click="handleLogin">Log in</span>
    </p>
  </div>
</template>

<script>
export default {
  name: "AlreadyHaveAnAccount",
  props: {
    type: {
      required: true,
      type: String,
    },
  },
  data() {
    return {};
  },
  methods: {
    handleLogin() {
      this.$router.push("/Login");
    },
    handleSignup() {
      this.$router.push("/register");
    },
  },
};
</script>

<style scoped lang="scss">
.already-have-an-account-container {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 14px;

  p {
    font-size: 14px;
    font-weight: 400;
    line-height: 18.2px;
    text-align: center;
    color: #282828;
    margin: 0;
    span {
      font-family: Montserrat;
      font-size: 14px;
      font-weight: 600;
      line-height: 18.2px;
      text-align: center;
      color: #50b848;
      text-decoration: underline;
      cursor: pointer;
    }
  }
}
.already-have-an-account-container.large-already {
  margin-top: 60px;
}
</style>
